import React from 'react';
import Button from '@amzn/awsui-components-console/button';
import SpaceBetween from '@amzn/awsui-components-console/space-between';
import Skeleton from '@amzn/awsui-components-console/skeleton';
import styles from '../StringGroupDetail.module.scss';

interface PageHeaderProps {
  title: string;
  onVersionHistoryClick: () => void;
  onEditGroupClick: () => void;
  /**
   * When false, editing controls are disabled (grayed out). This happens for
   * string groups owned by clients other than LangHub.
   */
  canEdit?: boolean;
  /**
   * Whether the permission answer is still in flight. Gated controls show a skeleton rather
   * than a disabled state, so they never claim a missing permission before it is known.
   */
  permissionsLoading?: boolean;
  /** Optional status indicator (e.g. "Unsaved changes") shown inline in the title row. */
  statusBadge?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  onVersionHistoryClick,
  onEditGroupClick,
  canEdit = true,
  permissionsLoading = false,
  statusBadge,
}) => (
  <div>
    <div className={styles.pageHeader}>
      <h1 className={styles.pageTitle}>
        {title}
        <span
          className={styles.infoIcon}
          title="A string group contains related strings that are translated together as a unit."
          aria-label="A string group contains related strings that are translated together as a unit."
          role="img"
        >
          ⓘ
        </span>
      </h1>
      <SpaceBetween direction="horizontal" size="xs">
        <Button onClick={onVersionHistoryClick}>Version History</Button>
        {permissionsLoading ? (
          <>
            <Skeleton display="inline-block" height="32px" width="105px" />
          </>
        ) : (
          <Button disabled={!canEdit} onClick={onEditGroupClick}>
            Edit Group
          </Button>
        )}
      </SpaceBetween>
      {statusBadge}
    </div>
    <p className={styles.pageDescription}>
      Create and manage your strings here.
    </p>
  </div>
);

export default PageHeader;
